export const OPERATOR_CUSTOM_NOTIFICATIONS_I18N_PREFIX = 'settings.operator-custom-notifications';

export const OPERATOR_CUSTOM_NOTIFICATIONS_UNAVAILABLE_KEY = `${OPERATOR_CUSTOM_NOTIFICATIONS_I18N_PREFIX}.list.notifications.unavailable`;

export const OPERATOR_CUSTOM_NOTIFICATIONS_BULK_ACTIONS_I18N_PREFIX = `${OPERATOR_CUSTOM_NOTIFICATIONS_I18N_PREFIX}.bulk-actions`;

export const NEW_NOTIFICATION_SEGMENT = 'new';
